var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qa app-container " }, [
    _c("div", { staticClass: "draw-title" }, [
      _c("img", {
        staticClass: "draw-title-img",
        attrs: { src: require("../../assets/qaRobot.png"), alt: "" }
      }),
      _c("p", { staticClass: "draw-title-top" }, [
        _vm._v(_vm._s(_vm.options[_vm.model]))
      ])
    ]),
    _c(
      "div",
      {
        staticClass: "draw-content",
        class: { bg1: _vm.model == "instQa", bg2: _vm.model == "riQa" }
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.model == "assistant",
                expression: "model == 'assistant'"
              }
            ],
            ref: "drawContent",
            staticClass: "draw-content-discuss",
            attrs: { id: "drawContent" }
          },
          [
            _c(
              "ul",
              { staticClass: "draw-content-discuss-list" },
              [
                _c("li", { staticClass: "draw-content-discuss-list-item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                    },
                    [
                      _c("img", {
                        staticClass:
                          "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                        attrs: { src: _vm.assistantImages, alt: "" }
                      })
                    ]
                  ),
                  _vm._m(0)
                ]),
                _vm._l(_vm.answerMsg, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "draw-content-discuss-list-item"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "draw-content-discuss-list-item-user",
                          class: {
                            "draw-content-discuss-list-item-user-left":
                              _vm.answerMsg[index] &&
                              _vm.answerMsg[index].type == "left",
                            "draw-content-discuss-list-item-user-right":
                              _vm.answerMsg[index] &&
                              _vm.answerMsg[index].type == "right"
                          }
                        },
                        [
                          _c("img", {
                            staticClass:
                              "draw-content-discuss-list-item-user-img",
                            attrs: {
                              src:
                                _vm.answerMsg[index].type == "right"
                                  ? _vm.images
                                  : _vm.assistantImages,
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "draw-content-discuss-list-item-user-talking",
                          class: {
                            "draw-content-discuss-list-item-user-talking-left":
                              _vm.answerMsg[index] &&
                              _vm.answerMsg[index].type == "left",
                            "draw-content-discuss-list-item-user-talking-right":
                              _vm.answerMsg[index] &&
                              _vm.answerMsg[index].type == "right"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "draw-content-discuss-list-item-user-talking-content"
                            },
                            [
                              _c("p", {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family":
                                    "PingFang SC, PingFang SC-Regular",
                                  "font-weight": "500",
                                  "text-align": "left",
                                  color: "#333333",
                                  "line-height": "22px",
                                  "white-space": "pre-wrap",
                                  "margin-top": "0",
                                  "margin-bottom": "0"
                                },
                                domProps: {
                                  innerHTML: _vm._s(_vm.answerMsg[index].msg)
                                }
                              })
                            ]
                          ),
                          _vm.answerMsg[index] &&
                          _vm.answerMsg[index].type == "left" &&
                          _vm.answerMsg[index].title &&
                          _vm.answerMsg[index].title.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user-talking-resource"
                                },
                                _vm._l(_vm.answerMsg[index].title, function(
                                  ele,
                                  i
                                ) {
                                  return _c(
                                    "p",
                                    {
                                      key: i,
                                      staticClass:
                                        "draw-content-discuss-list-item-user-talking-resource-item",
                                      attrs: { title: i + 1 + "." + ele.title },
                                      on: {
                                        click: function($event) {
                                          return _vm.toInst(ele)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(i + 1 + "." + ele.title))]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                }),
                false
                  ? _c(
                      "li",
                      { staticClass: "draw-content-discuss-list-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                          },
                          [
                            _c("img", {
                              staticClass:
                                "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                              attrs: { src: _vm.assistantImages, alt: "" }
                            })
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "draw-content-discuss-list-item-user-talking-content"
                              },
                              [
                                _c(
                                  "el-skeleton",
                                  { attrs: { animated: "" } },
                                  [
                                    _c(
                                      "template",
                                      { slot: "template" },
                                      [
                                        _c("el-skeleton-item", {
                                          staticStyle: {
                                            width: "80px",
                                            "margin-right": "26px"
                                          },
                                          attrs: { variant: "text" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticStyle: { width: "1px", height: "200px" } })
              ],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.model == "instQa",
                expression: "model == 'instQa'"
              }
            ],
            ref: "instDrawContentScroll",
            staticClass: "draw-content-discuss",
            attrs: { id: "instDrawContentScroll" }
          },
          [
            _c(
              "ul",
              { staticClass: "draw-content-discuss-list" },
              [
                _c("li", { staticClass: "draw-content-discuss-list-item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                    },
                    [
                      _c("img", {
                        staticClass:
                          "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                        attrs: { src: _vm.assistantImages, alt: "" }
                      })
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "draw-content-discuss-list-item-user-talking-content"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#333",
                                "line-height": "18px",
                                "white-space": "pre-wrap",
                                "margin-top": "0",
                                "margin-bottom": "8px"
                              }
                            },
                            [
                              _vm._v(
                                "我是小合，您有用的政策咨询助手。我知道的知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我："
                              )
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#1890FF",
                                "line-height": "18px",
                                "white-space": "pre-wrap",
                                "margin-top": "0",
                                "margin-bottom": "8px",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getQuestion(
                                    "银行审慎监管主要包括哪些方面？"
                                  )
                                }
                              }
                            },
                            [_vm._v("银行员工考勤管理主要包括哪些内容？")]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#1890FF",
                                "line-height": "18px",
                                "white-space": "pre-wrap",
                                "margin-top": "0",
                                "margin-bottom": "8px",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getQuestion(
                                    "银行审慎监管主要包括哪些方面？"
                                  )
                                }
                              }
                            },
                            [_vm._v("流动资金贷款贷后管理主要包括哪些内容？")]
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _vm._l(_vm.instAnswerMsg, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "draw-content-discuss-list-item"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "draw-content-discuss-list-item-user",
                          class: {
                            "draw-content-discuss-list-item-user-left":
                              _vm.instAnswerMsg[index] &&
                              _vm.instAnswerMsg[index].type == "left",
                            "draw-content-discuss-list-item-user-right":
                              _vm.instAnswerMsg[index] &&
                              _vm.instAnswerMsg[index].type == "right"
                          }
                        },
                        [
                          _c("img", {
                            staticClass:
                              "draw-content-discuss-list-item-user-img",
                            attrs: {
                              src:
                                _vm.instAnswerMsg[index].type == "right"
                                  ? _vm.images
                                  : _vm.assistantImages,
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "draw-content-discuss-list-item-user-talking",
                          class: {
                            "draw-content-discuss-list-item-user-talking-left":
                              _vm.instAnswerMsg[index] &&
                              _vm.instAnswerMsg[index].type == "left",
                            "draw-content-discuss-list-item-user-talking-right":
                              _vm.instAnswerMsg[index] &&
                              _vm.instAnswerMsg[index].type == "right"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "draw-content-discuss-list-item-user-talking-content"
                            },
                            [
                              _c("p", {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family":
                                    "PingFang SC, PingFang SC-Regular",
                                  "font-weight": "500",
                                  "text-align": "left",
                                  color: "#333333",
                                  "line-height": "22px",
                                  "white-space": "pre-wrap",
                                  "margin-top": "0",
                                  "margin-bottom": "0"
                                },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.instAnswerMsg[index].msg
                                  )
                                }
                              })
                            ]
                          ),
                          _vm.instAnswerMsg[index] &&
                          _vm.instAnswerMsg[index].type == "left" &&
                          _vm.instAnswerMsg[index].title &&
                          _vm.instAnswerMsg[index].title.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user-talking-resource"
                                },
                                _vm._l(_vm.instAnswerMsg[index].title, function(
                                  ele,
                                  i
                                ) {
                                  return _c(
                                    "p",
                                    {
                                      key: i,
                                      staticClass:
                                        "draw-content-discuss-list-item-user-talking-resource-item",
                                      attrs: { title: i + 1 + "." + ele.title },
                                      on: {
                                        click: function($event) {
                                          return _vm.toInst(ele)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(i + 1 + "." + ele.title))]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                }),
                false
                  ? _c(
                      "li",
                      { staticClass: "draw-content-discuss-list-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                          },
                          [
                            _c("img", {
                              staticClass:
                                "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                              attrs: { src: _vm.assistantImages, alt: "" }
                            })
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "draw-content-discuss-list-item-user-talking-content"
                              },
                              [
                                _c(
                                  "el-skeleton",
                                  { attrs: { animated: "" } },
                                  [
                                    _c(
                                      "template",
                                      { slot: "template" },
                                      [
                                        _c("el-skeleton-item", {
                                          staticStyle: {
                                            width: "80px",
                                            "margin-right": "26px"
                                          },
                                          attrs: { variant: "text" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticStyle: { width: "1px", height: "200px" } })
              ],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.model == "riQa",
                expression: "model == 'riQa'"
              }
            ],
            ref: "riDrawContentScroll",
            staticClass: "draw-content-discuss",
            attrs: { id: "riDrawContentScroll" }
          },
          [
            _c(
              "ul",
              { staticClass: "draw-content-discuss-list" },
              [
                _c("li", { staticClass: "draw-content-discuss-list-item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                    },
                    [
                      _c("img", {
                        staticClass:
                          "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                        attrs: { src: _vm.assistantImages, alt: "" }
                      })
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "draw-content-discuss-list-item-user-talking-content"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#333",
                                "line-height": "18px",
                                "white-space": "pre-wrap",
                                "margin-top": "0",
                                "margin-bottom": "8px"
                              }
                            },
                            [
                              _vm._v(
                                "我是小合，您有用的政策咨询助手。我知道的知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我："
                              )
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#1890FF",
                                "line-height": "18px",
                                "white-space": "pre-wrap",
                                "margin-top": "0",
                                "margin-bottom": "8px",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getQuestion(
                                    "银行审慎监管主要包括哪些方面？"
                                  )
                                }
                              }
                            },
                            [_vm._v("银行员工考勤管理主要包括哪些内容？")]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#1890FF",
                                "line-height": "18px",
                                "white-space": "pre-wrap",
                                "margin-top": "0",
                                "margin-bottom": "8px",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getQuestion(
                                    "银行审慎监管主要包括哪些方面？"
                                  )
                                }
                              }
                            },
                            [_vm._v("流动资金贷款贷后管理主要包括哪些内容？")]
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _vm._l(_vm.riAnswerMsg, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "draw-content-discuss-list-item"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "draw-content-discuss-list-item-user",
                          class: {
                            "draw-content-discuss-list-item-user-left":
                              _vm.riAnswerMsg[index] &&
                              _vm.riAnswerMsg[index].type == "left",
                            "draw-content-discuss-list-item-user-right":
                              _vm.riAnswerMsg[index] &&
                              _vm.riAnswerMsg[index].type == "right"
                          }
                        },
                        [
                          _c("img", {
                            staticClass:
                              "draw-content-discuss-list-item-user-img",
                            attrs: {
                              src:
                                _vm.riAnswerMsg[index].type == "right"
                                  ? _vm.images
                                  : _vm.assistantImages,
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "draw-content-discuss-list-item-user-talking",
                          class: {
                            "draw-content-discuss-list-item-user-talking-left":
                              _vm.riAnswerMsg[index] &&
                              _vm.riAnswerMsg[index].type == "left",
                            "draw-content-discuss-list-item-user-talking-right":
                              _vm.riAnswerMsg[index] &&
                              _vm.riAnswerMsg[index].type == "right"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "draw-content-discuss-list-item-user-talking-content"
                            },
                            [
                              _c("p", {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family":
                                    "PingFang SC, PingFang SC-Regular",
                                  "font-weight": "500",
                                  "text-align": "left",
                                  color: "#333333",
                                  "line-height": "22px",
                                  "white-space": "pre-wrap",
                                  "margin-top": "0",
                                  "margin-bottom": "0"
                                },
                                domProps: {
                                  innerHTML: _vm._s(_vm.riAnswerMsg[index].msg)
                                }
                              })
                            ]
                          ),
                          _vm.riAnswerMsg[index] &&
                          _vm.riAnswerMsg[index].type == "left" &&
                          _vm.riAnswerMsg[index].title &&
                          _vm.riAnswerMsg[index].title.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user-talking-resource"
                                },
                                _vm._l(_vm.riAnswerMsg[index].title, function(
                                  ele,
                                  i
                                ) {
                                  return _c(
                                    "p",
                                    {
                                      key: i,
                                      staticClass:
                                        "draw-content-discuss-list-item-user-talking-resource-item",
                                      attrs: { title: i + 1 + "." + ele.title },
                                      on: {
                                        click: function($event) {
                                          return _vm.toInst(ele)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(i + 1 + "." + ele.title))]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                }),
                false
                  ? _c(
                      "li",
                      { staticClass: "draw-content-discuss-list-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                          },
                          [
                            _c("img", {
                              staticClass:
                                "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                              attrs: { src: _vm.assistantImages, alt: "" }
                            })
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "draw-content-discuss-list-item-user-talking-content"
                              },
                              [
                                _c(
                                  "el-skeleton",
                                  { attrs: { animated: "" } },
                                  [
                                    _c(
                                      "template",
                                      { slot: "template" },
                                      [
                                        _c("el-skeleton-item", {
                                          staticStyle: {
                                            width: "80px",
                                            "margin-right": "26px"
                                          },
                                          attrs: { variant: "text" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticStyle: { width: "1px", height: "200px" } })
              ],
              2
            )
          ]
        ),
        _c("div", { staticClass: "draw-content-input" }, [
          _c(
            "div",
            { staticClass: "draw-content-input-search" },
            [
              !_vm.disClick
                ? _c("el-input", {
                    ref: "inputName",
                    staticStyle: {
                      "font-size": "14px",
                      "font-family": "PingFang SC, PingFang SC-Regular",
                      "font-weight": "400",
                      "text-align": "left",
                      color: "#333333",
                      "line-height": "20px",
                      "background-color": "#fff",
                      height: "80px",
                      "min-height": "80px"
                    },
                    attrs: {
                      placeholder: "请输入你想要咨询的问题",
                      autosize: { minRows: 4, maxRows: 4 },
                      type: "textarea",
                      clearable: "",
                      resize: "none"
                    },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.disClick ? "" : _vm.carriageReturn($event)
                      }
                    },
                    model: {
                      value: _vm.question,
                      callback: function($$v) {
                        _vm.question = $$v
                      },
                      expression: "question"
                    }
                  })
                : _vm._e(),
              _vm.disClick
                ? _c(
                    "p",
                    {
                      staticClass: "draw-content-input-cancelButton",
                      on: { click: _vm.cancelQa }
                    },
                    [
                      _c("i", {
                        staticStyle: {
                          display: "inline-block",
                          width: "18px",
                          height: "18px",
                          "background-color": "#174ae4",
                          "margin-right": "5px"
                        }
                      }),
                      _vm._v(" 停止响应 ")
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          !_vm.disClick
            ? _c(
                "div",
                {
                  staticClass: "draw-content-input-send",
                  class: {
                    "draw-content-input-send-active":
                      _vm.question.trim().length > 0
                  },
                  on: {
                    click: function($event) {
                      _vm.disClick && _vm.question.trim().length > 0
                        ? ""
                        : _vm.sendBtn()
                    }
                  }
                },
                [_vm._v(" 发送 ")]
              )
            : _vm._e(),
          _c("div", { staticClass: "draw-content-input-selBtn" }, [
            _c(
              "div",
              {
                staticClass: "draw-content-input-option ",
                class: {
                  "draw-content-input-selected": _vm.model == "assistant"
                },
                on: {
                  click: function($event) {
                    return _vm.checkModel("assistant")
                  }
                }
              },
              [_c("span", [_vm._v("闲聊")])]
            ),
            _c(
              "div",
              {
                staticClass: "draw-content-input-option",
                class: {
                  "draw-content-input-selected1": _vm.model == "instQa"
                },
                on: {
                  click: function($event) {
                    return _vm.checkModel("instQa")
                  }
                }
              },
              [_c("span", [_vm._v("制度")]), _c("span", [_vm._v("问答")])]
            ),
            _c(
              "div",
              {
                staticClass: "draw-content-input-option",
                class: { "draw-content-input-selected2": _vm.model == "riQa" },
                on: {
                  click: function($event) {
                    return _vm.checkModel("riQa")
                  }
                }
              },
              [_c("span", [_vm._v("政策")]), _c("span", [_vm._v("问答")])]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
      },
      [
        _c(
          "div",
          {
            staticClass: "draw-content-discuss-list-item-user-talking-content"
          },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "14px",
                  color: "#333",
                  "line-height": "18px",
                  "white-space": "pre-wrap",
                  "margin-top": "0",
                  "margin-bottom": "8px"
                }
              },
              [
                _vm._v(
                  "我是小合，您可以问我任何问题。我知道的知识有限，因此我的回答难免出现错误，请您谅解。"
                )
              ]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }